import { Box } from '@mui/material';

/** Figma 8736:25533 — Rectangle 168 */
export const PASS_BUY_FOOTER_WIDTH = 400;
export const PASS_BUY_FOOTER_HEIGHT = 56;
export const PASS_BUY_FOOTER_RADIUS = 20;

const passBuyFooterGradient = 'linear-gradient(180deg, #ff00f2 0%, #822aff 100%)';

export default function PassBuyFooter({ children, onClick, sx, ...props }) {
  return (
    <Box
      component={onClick ? 'button' : 'div'}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      sx={{
        width: '100%',
        height: PASS_BUY_FOOTER_HEIGHT,
        minHeight: PASS_BUY_FOOTER_HEIGHT,
        border: 'none',
        p: 0,
        overflow: 'hidden',
        background: passBuyFooterGradient,
        borderBottomLeftRadius: `${PASS_BUY_FOOTER_RADIUS}px`,
        borderBottomRightRadius: `${PASS_BUY_FOOTER_RADIUS}px`,
        display: 'grid',
        placeItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
